import { ClaimDTO, RecallDTO, SalesOrderDTO, ViewVinRegistrationDTO } from 'src/services/generated/api.generated.v1';
import { MutationTree } from 'vuex';
import { VehicleClaims, VehicleRecalls, VehicleSalesOrders, VehicleStateInterface } from './state';

const mutation: MutationTree<VehicleStateInterface> = {
    setVinRegistrations(state: VehicleStateInterface, vinRegistrations: Array<ViewVinRegistrationDTO>) {
        state.vinRegistrations = vinRegistrations;
    },

    setClaims(state: VehicleStateInterface, { vehicleUid, claims }: { vehicleUid: string, claims: Array<ClaimDTO>, }) {
        const claimsIndex = state.claims.findIndex((search: VehicleClaims) => search.vehicleUid === vehicleUid);

        if (claimsIndex === -1) {
            state.claims.push({ vehicleUid: vehicleUid, claims: claims});
        } else {
            state.claims[claimsIndex] = { vehicleUid: vehicleUid, claims: claims};
        }
    },    
    
    setRecalls(state: VehicleStateInterface, { vehicleUid, recalls, }: { vehicleUid: string, recalls: Array<RecallDTO>, }) {
        const recallIndex = state.recalls.findIndex((search: VehicleRecalls) => search.vehicleUid === vehicleUid);

        if (recallIndex === -1) {
            state.recalls.push({ vehicleUid: vehicleUid, recalls: recalls});
        } else {
            state.recalls[recallIndex] = { vehicleUid: vehicleUid, recalls: recalls};
        }
    },

    setSalesOrders(state: VehicleStateInterface, { vehicleUid, salesOrders, }: { vehicleUid: string, salesOrders: Array<SalesOrderDTO>, }) {
        const salesOrderIndex = state.salesOrders.findIndex((search: VehicleSalesOrders) => search.vehicleUid === vehicleUid);

        if (salesOrderIndex === -1) {
            state.salesOrders.push({ vehicleUid: vehicleUid, salesOrders: salesOrders});
        } else {
            state.salesOrders[salesOrderIndex] = { vehicleUid: vehicleUid, salesOrders: salesOrders};
        }
    },
}

export default mutation;